// remove duplicated elements in an array
export function make_distinct(arr) {
    let arr_input = JSON.parse(JSON.stringify(arr))
    let arr_set = new Set(arr_input)
    let arr_distinct = [...arr_set]

    return arr_distinct
}

export function is_equal_set(list_a, list_b) {
    let set_a = new Set(list_a)
    let set_b = new Set(list_b)
    if (set_a.size !== set_b.size) return false;
    for (var a of set_a)
        if (!set_b.has(a)) return false;
    return true
}

// arr_props_dir [{prop: ... , dir: 1}, {}]
export function sort_obj_array(arr_obj, arr_props_dir) {
    let obj_array = JSON.parse(JSON.stringify(arr_obj))
    let sortBy = []
    for (let j = 0; j < arr_props_dir.length; j++) {
        let propdir = arr_props_dir[j]
        sortBy.push({
            prop: propdir.prop,
            dir: propdir.dir
        })
    }
    obj_array.sort(function(a, b) {
        let i = 0,
            result = 0;
        let xa = ""
        let xb = ""
        while (i < sortBy.length && result === 0) {
            xa = a[sortBy[i].prop]
            xb = b[sortBy[i].prop]
            result = sortBy[i].dir * (String(xa) < String(xb) ? -1 : (String(xa) > String(xb) ? 1 : 0))
            i++
        }
        return result
    })
    return obj_array
}

export function delete_null_prop(obj) {
    var propName = Object.getOwnPropertyNames(obj)
    for (propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName]
        }
    }
    return obj
}

export function is_valid(value) {
    if (value == "" || value == null || value == undefined || (value != null && typeof value == "object" && !Object.keys(value).length)) {
        return false
    } else {
        return true
    }
}

export function splitTextToArray(text) {
    text = text.replace(',', ' ')
    let textArray = text.split(/(\s+)/)
        .filter(e => e.trim().length > 0)
        // console.log('F/splitTextToArray - input, output ', text, textArray)
    return textArray
}

export function array_element_move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length
    }
    while (new_index < 0) {
        new_index += arr.length
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
        // console.log('function/array_element_move', old_index, '->', new_index)
    return arr
}

export function numberWithCommas(x) {
    if (x > 1000) {
        return x.toLocaleString()
    } else {
        return x
    }
}

// usage -> const result = groupBy('prop')
// https://gist.github.com/JamieMason/0566f8412af9fe6a1d470aa1e089a752

export const groupBy = key => array =>
    array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});


// WEBPACK FOOTER //
// ./src/custom/fn_general.js